/* BroxiBox custom sections â€” shared behavior. Init-guarded so it runs once,
   and re-runs safely when Shopify's theme editor reloads a section. */
(function(){
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMarquee(root){
    var t = root.querySelector('[data-bx-marquee-track]');
    if(!t || t.dataset.bxInit) return;
    t.dataset.bxInit = '1';
    t.innerHTML = t.innerHTML + t.innerHTML;
  }

  function initReveals(scope){
    var els = (scope||document).querySelectorAll('.bx-fx:not(.bx-in)');
    if(!els.length) return;
    if(!('IntersectionObserver' in window) || reduced){
      els.forEach(function(el){el.classList.add('bx-in');});
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('bx-in');io.unobserve(e.target);}
      });
    },{threshold:.16});
    els.forEach(function(el){io.observe(el);});
  }

  function initHero(root){
    var media = root.querySelector('[data-bx-hero-media]');
    if(!media || media.dataset.bxInit) return;
    media.dataset.bxInit = '1';

    /* staggered headline words.
       Skip entirely inside Shopify's theme editor: it injects comment
       nodes around editable text that must not be disturbed. */
    var inEditor = window.Shopify && window.Shopify.designMode;
    var h = root.querySelector('[data-bx-hero-title]');
    if(h && !h.dataset.bxSplit && !inEditor){
      h.dataset.bxSplit = '1';
      var i0 = 0;
      /* Walk only direct children: wrap words in text nodes, keep element
         nodes (like <em>) as single animated units. Comment nodes are left alone. */
      var kids = Array.prototype.slice.call(h.childNodes);
      var frag = document.createDocumentFragment();
      kids.forEach(function(node){
        if(node.nodeType === 3){ /* text node */
          node.nodeValue.split(/\s+/).forEach(function(word){
            if(!word) return;
            var s = document.createElement('span');
            s.className = 'bx-w'; s.textContent = word;
            s.style.animationDelay = (0.15 + (i0++)*0.12) + 's';
            frag.appendChild(s); frag.appendChild(document.createTextNode(' '));
          });
        } else if(node.nodeType === 1){ /* element node, e.g. <em> */
          var w = document.createElement('span');
          w.className = 'bx-w';
          w.style.animationDelay = (0.15 + (i0++)*0.12) + 's';
          w.appendChild(node.cloneNode(true));
          frag.appendChild(w); frag.appendChild(document.createTextNode(' '));
        }
        /* nodeType 8 (comment) intentionally skipped */
      });
      h.innerHTML = '';
      h.appendChild(frag);
    }

    var v = media.querySelector('video');
    var f = media.querySelector('[data-bx-hero-fallback]');
    var label = media.querySelector('[data-bx-hero-label]');
    var dots = media.querySelector('[data-bx-hero-dots]');
    var scenes = [];
    try { scenes = JSON.parse(media.dataset.bxScenes || '[]'); } catch(e){}
    var i = 0, timer = null;

    function go(n){
      i = n % scenes.length;
      media.className = media.className.replace(/\bbx-scene-\d\b/g,'').trim();
      if(i > 0) media.classList.add('bx-scene-' + i);
      if(label){
        label.classList.add('bx-fade');
        setTimeout(function(){label.textContent = scenes[i]; label.classList.remove('bx-fade');}, 800);
      }
      if(dots) dots.querySelectorAll('i').forEach(function(d,k){d.classList.toggle('bx-on', k === i);});
    }
    function start(){ if(!reduced && !timer && scenes.length > 1) timer = setInterval(function(){go(i+1);}, 4600); }
    function stop(){ clearInterval(timer); timer = null; media.className = media.className.replace(/\bbx-scene-\d\b/g,'').trim(); }

    if(v){
      v.addEventListener('loadeddata', function(){
        stop();
        if(f) f.style.display = 'none';
        if(label) label.style.display = 'none';
        if(dots) dots.style.display = 'none';
      });
      v.addEventListener('error', function(){ v.style.display = 'none'; start(); }, true);
      setTimeout(function(){ if(v.readyState < 2) start(); }, 1200);
    } else {
      start();
    }
  }

  function initSlider(root){
    var el = root.querySelector('[data-bx-slider]');
    if(!el || el.dataset.bxInit) return;
    el.dataset.bxInit = '1';
    var x = 50;
    function set(v){
      x = Math.max(0, Math.min(100, v));
      el.style.setProperty('--bx-x', x + '%');
      el.setAttribute('aria-valuenow', Math.round(x));
    }
    function fromEvent(e){
      var r = el.getBoundingClientRect();
      var cx = (e.touches ? e.touches[0].clientX : e.clientX);
      set((cx - r.left) / r.width * 100);
    }
    var drag = false;
    el.addEventListener('pointerdown', function(e){ drag = true; el.setPointerCapture(e.pointerId); fromEvent(e); });
    el.addEventListener('pointermove', function(e){ if(drag) fromEvent(e); });
    el.addEventListener('pointerup', function(){ drag = false; });
    el.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ set(x - 4); e.preventDefault(); }
      if(e.key === 'ArrowRight'){ set(x + 4); e.preventDefault(); }
    });
    set(50);
  }

  function initWaitlist(root){
    var form = root.querySelector('.bx-waitlist-form');
    if(!form || form.dataset.bxInit) return;
    form.dataset.bxInit = '1';
    var companyId = root.dataset.bxKlaviyoCompany;
    var listId = root.dataset.bxKlaviyoList;
    if(!companyId || !listId) return; /* no Klaviyo config: submit natively to Shopify */
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var email = form.querySelector('input[type=email]').value;
      var done = root.querySelector('[data-bx-waitlist-done]');
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method:'POST',
        headers:{'Content-Type':'application/json','revision':'2024-10-15'},
        body: JSON.stringify({data:{type:'subscription',
          attributes:{profile:{data:{type:'profile',attributes:{email:email}}}},
          relationships:{list:{data:{type:'list',id:listId}}}}})
      }).finally(function(){
        form.style.display = 'none';
        if(done) done.style.display = 'block';
      });
    });
  }

  function initAll(scope){
    var s = scope || document;
    s.querySelectorAll('[data-bx-section]').forEach(function(root){
      var kind = root.dataset.bxSection;
      if(kind === 'marquee') initMarquee(root);
      if(kind === 'hero') initHero(root);
      if(kind === 'before-after') initSlider(root);
      if(kind === 'waitlist') initWaitlist(root);
    });
    initReveals(s);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  /* Shopify theme editor: re-init when a section reloads */
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();